module.exports = __webpack_public_path__ + "static/media/social-x-white.b676e408.svg";